class PropertiesSearchBarHandlerClass extends elementorModules.frontend.handlers
  .Base {
  /**
   * On Init
   *
   * Runs when the widget is loaded and initialized in the frontend.
   */
  onInit() {
    const widgetIdentifier = `div[data-id="${this.getID()}"]`;

    (function ($) {
      $(document).ready(function () {
        const $widget = $(widgetIdentifier);

        const $json = $widget.find('script[type="application/json"]');

        let locationsSource = {};

        if ($json.length) {
          // for the spaces to work inside the select2 options
          locationsSource = JSON.parse($json.text().replace(/\s/g, "\xa0"));
        }

        // init select2 default config
        const select2DefaultOptions = {
          minimumResultsForSearch: Infinity,
        };

        let select2Boxes = [
          {
            class: ".casafari-search-bar__business",
            options: select2DefaultOptions,
            instance: null,
          },
          {
            class: ".casafari-search-bar__type",
            options: select2DefaultOptions,
            instance: null,
          },
          {
            class: ".casafari-search-bar__country",
            options: select2DefaultOptions,
            instance: null,
            callbackSelect: function (e) {
              let data = e.params.data;
              //console.log(data.id);

              let locations = [
                {
                  id: -1,
                  text: casafariData.labelAllLocations,
                },
              ];

              // all countries locations === -1
              if (data.id === "-1") {
                // get all locations
                Object.values(locationsSource).map((locationsOptions) => {
                  locations = locations.concat(locationsOptions);
                });
              } else {
                // get specific country locations
                locations = locations.concat(locationsSource[data.id]);
              }

              select2Boxes.forEach((select2Box) => {
                if (select2Box.class === ".casafari-search-bar__locations") {
                  const select2Options = {
                    data: locations,
                    minimumResultsForSearch: Infinity,
                  };
                  select2Box.instance.val(null).empty().select2("destroy");
                  select2Box.instance.select2(select2Options).trigger("change");
                }
              });
            },
          },
          {
            class: ".casafari-search-bar__locations",
            options: select2DefaultOptions,
            instance: null,
          },
          {
            class: ".casafari-search-bar__bedrooms",
            options: select2DefaultOptions,
            instance: null,
          },
          {
            class: ".casafari-search-bar__price-min",
            options: select2DefaultOptions,
            instance: null,
          },
          {
            class: ".casafari-search-bar__price-max",
            options: select2DefaultOptions,
            instance: null,
          },
        ];

        select2Boxes.forEach((select2Box) => {
          select2Box.instance = $(`${select2Box.class}`).select2(
            select2Box.options
          );

          if (select2Box.callbackSelect) {
            select2Box.instance.on("select2:select", select2Box.callbackSelect);
          }
        });
      });
    })(jQuery);
  }
}

// init handler
/**
 * Registers the `widget-search-bar` element handler.
 *
 * The handler is responsible for initializing the Swiper slider.
 *
 * @param {jQuery} $ - jQuery object.
 */
(function ($) {
  $(window).on("elementor/frontend/init", () => {
    elementorFrontend.elementsHandler.attachHandler(
      "widget-search-bar",
      PropertiesSearchBarHandlerClass
    );
  });
})(jQuery);
